import { graphql } from '@graphql/gql';

export const REVOKE_PUB_NUB_AUTH_KEY = graphql(`
  mutation REVOKE_PUB_NUB_AUTH_KEY($authKey: ID!) {
    revokePubNubAuthKey(authKey: $authKey)
  }
`);
